import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { SteppedProgressBar } from '@alfalab/core-components-stepped-progress-bar';
import { HatchingProgressBar } from '@alfalab/core-components-hatching-progress-bar';
import { TextDesktop } from '@alfa-bank/site-text-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';

import type { TProgressBarV2, IDeps } from './models';
import { ProgressBarV2 as Component } from './progress-bar-v2';
import styles from './styles/styles.css';

export const ProgressBarV2Desktop = createWidget<IDeps, TProgressBarV2>({
    HatchingProgressBar,
    SteppedProgressBar,
    Grid,
    Text: TextDesktop,
    styles,
})(Component);
